
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/migration/migration-v0x",
      function () {
        return require("private-next-pages/material-ui/migration/migration-v0x.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/migration/migration-v0x"])
      });
    }
  